import axios from "axios";

import { createPasskeyCredential } from "@util/passkeys";

export async function enrollPasskey(nickname) {
  const trimmed = (nickname || "").trim();
  if (!trimmed) {
    throw new Error(
      "Give this passkey a nickname that describes the device, like My iPhone."
    );
  }

  const { data: optionsData } = await axios.post(
    "/passkeys/registration/options/",
    {}
  );
  const options = optionsData.response[0];
  const credential = await createPasskeyCredential(options);
  const { data } = await axios.post("/passkeys/registration/verify/", {
    ceremony_id: options.ceremony_id,
    credential,
    nickname: trimmed,
    transports: credential.response?.transports,
  });
  return data.response[0];
}

export function passkeyPromptStorageKey(actor) {
  if (!actor) return null;
  const id = actor.admin_id || actor.user_id || actor.id;
  if (!id) return null;
  return `clearscreen-passkey-prompt-dismissed:${id}`;
}
